// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type ScalarsSelector<T> = {
  [X in Required<{
    [P in keyof T]: T[P] extends number | string | undefined | boolean ? P : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([, value]) => {
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType || (typeof isReturnType === 'string' && isReturnType.startsWith('scalar.'))) {
          return true;
        }
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T]>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["AuthType"]

export type ValueTypes = {
    ["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ValueTypes["Roles"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["Roles"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ValueTypes["Permissions"],
	users?:ValueTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["Avatar"]: AliasType<{
	id?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatedUserTokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	isChallengeable?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ValueTypes["Roles"],
	roleId?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ValueTypes["User"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LeaderboardEntry"]: AliasType<{
	username?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
		__typename?: boolean | `@${string}`
}>;
	["UpdatedUser"]: AliasType<{
	username?:boolean | `@${string}`,
	isChallengeable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatedUserWithTokens"]: AliasType<{
	tokens?:ValueTypes["UpdatedUserTokens"],
	updatedUser?:ValueTypes["UpdatedUser"],
		__typename?: boolean | `@${string}`
}>;
	["Tokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	sub?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AuthUser"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	isChallengeable?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrackedAnswer"]: AliasType<{
	id?:boolean | `@${string}`,
	answerId?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SoloTracking"]: AliasType<{
	id?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	isCompleted?:boolean | `@${string}`,
	finalScore?:boolean | `@${string}`,
	trackedAnswers?:ValueTypes["TrackedAnswer"],
		__typename?: boolean | `@${string}`
}>;
	["ValidatedAnswer"]: AliasType<{
	tracking?:ValueTypes["SoloTracking"],
	correctAnswerId?:boolean | `@${string}`,
	turn?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleCheck"]: AliasType<{
	hasFinishedBattles?:boolean | `@${string}`,
	hasPendingBattles?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleScore"]: AliasType<{
	turn?:boolean | `@${string}`,
	crownCount?:boolean | `@${string}`,
	badges?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChallengeableUser"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	wonBattles?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
	battleStatus?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleStatus"]:BattleStatus;
	["SentBattles"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	wonBattles?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
	battleStatus?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleUser"]: AliasType<{
	username?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
	id?:boolean | `@${string}`,
	score?:ValueTypes["BattleScore"],
		__typename?: boolean | `@${string}`
}>;
	["BattleTracking"]: AliasType<{
	id?:boolean | `@${string}`,
	battlePlayerTrackingId?:boolean | `@${string}`,
	challenger?:ValueTypes["BattleUser"],
	challenged?:ValueTypes["BattleUser"],
	currentPlayerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PendingBattle"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	challenger?:ValueTypes["ChallengeableUser"],
	ttl?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	currentPlayerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinishedBattle"]: AliasType<{
	isWinner?:boolean | `@${string}`,
	isChallenger?:boolean | `@${string}`,
	opponent?:ValueTypes["BattleUser"],
	date?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableChallengers"]: AliasType<{
	challengeableFriends?:ValueTypes["ChallengeableUser"],
	challengeableUsers?:ValueTypes["ChallengeableUser"],
		__typename?: boolean | `@${string}`
}>;
	["Winner"]: AliasType<{
	opponent?:boolean | `@${string}`,
	isWinner?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleNotification"]: AliasType<{
	from?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	isWinner?:boolean | `@${string}`,
	battlePlayerTrackingId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationType"]:NotificationType;
	["ValidatedBattleAnswer"]: AliasType<{
	currentTurn?:boolean | `@${string}`,
	badges?:boolean | `@${string}`,
	crownCount?:boolean | `@${string}`,
	correctAnswerId?:boolean | `@${string}`,
	turnEnded?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidatedCrown"]: AliasType<{
	crownCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Friend"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	wonBattles?:boolean | `@${string}`,
	avatar?:ValueTypes["Avatar"],
	isFriend?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Theme"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	wheelFileName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Picture"]: AliasType<{
	id?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CurrentThemeAnswers"]: AliasType<{
	index?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartialAnswer"]: AliasType<{
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Question"]: AliasType<{
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	theme?:ValueTypes["Theme"],
	answers?:ValueTypes["PartialAnswer"],
	picture?:ValueTypes["Picture"],
		__typename?: boolean | `@${string}`
}>;
	["QuestionsWithStatus"]: AliasType<{
	questions?:ValueTypes["Question"],
	currentThemeAnswers?:ValueTypes["CurrentThemeAnswers"],
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ValueTypes["Health"],
getRole?: [{	id: number | Variable<any, string>},ValueTypes["Roles"]],
	getRoles?:ValueTypes["Roles"],
getPermission?: [{	id: number | Variable<any, string>},ValueTypes["Permissions"]],
	getPermissions?:ValueTypes["Permissions"],
getMail?: [{	id: number | Variable<any, string>},ValueTypes["Mail"]],
	getMails?:ValueTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string | Variable<any, string>},ValueTypes["AuthType"]],
login?: [{	username: string | Variable<any, string>},ValueTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string | Variable<any, string>},ValueTypes["UniqueAuth"]],
getUser?: [{	id: number | Variable<any, string>},ValueTypes["User"]],
	getUsers?:ValueTypes["User"],
	getLeaderboard?:ValueTypes["LeaderboardEntry"],
	findOpponents?:ValueTypes["User"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ValueTypes["FindManyUserWithFiltersInput"] | Variable<any, string>},ValueTypes["UserPagination"]],
	getThemes?:ValueTypes["Theme"],
getQuestionById?: [{	questionId: string | Variable<any, string>},ValueTypes["Question"]],
getRandomQuestions?: [{	themeId?: string | undefined | null | Variable<any, string>,	trackingId: string | Variable<any, string>},ValueTypes["QuestionsWithStatus"]],
getBattleQuestion?: [{	themeId?: string | undefined | null | Variable<any, string>,	battlePlayerTrackingId: string | Variable<any, string>},ValueTypes["Question"]],
	getTrackings?:ValueTypes["SoloTracking"],
getTrackingById?: [{	trackingId: string | Variable<any, string>},ValueTypes["SoloTracking"]],
	getAvatars?:ValueTypes["Avatar"],
getBattlePlayerTrackingById?: [{	battlePlayerTrackingId: string | Variable<any, string>},ValueTypes["BattleTracking"]],
getAvailableChallengers?: [{	searchText?: string | undefined | null | Variable<any, string>},ValueTypes["AvailableChallengers"]],
	getPendingBattles?:ValueTypes["PendingBattle"],
	getSentBattles?:ValueTypes["SentBattles"],
	getFinishedBattles?:ValueTypes["FinishedBattle"],
getWinner?: [{	battleTrackingId: string | Variable<any, string>},ValueTypes["Winner"]],
	checkBattles?:ValueTypes["BattleCheck"],
	getFriendsList?:ValueTypes["Friend"],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{		["...on AuthReponse"]?: ValueTypes["AuthReponse"],
		["...on CustomError"]?: ValueTypes["CustomError"]
		__typename?: boolean | `@${string}`
}>;
	["AuthReponse"]: AliasType<{
	tokens?:ValueTypes["Tokens"],
	user?:ValueTypes["AuthUser"],
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput: string | Variable<any, string>,
	orderBy?: ValueTypes["UserOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["UserFilterByInput"] | undefined | null | Variable<any, string>
};
	["UserOrderByInput"]: {
	email?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastConnectionAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined | null | Variable<any, string>
};
	["Mutation"]: AliasType<{
register?: [{	username: string | Variable<any, string>,	avatarId: string | Variable<any, string>},ValueTypes["AuthType"]],
askForResetPassword?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
resetPassword?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
verifyEmail?: [{	email: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegister?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},boolean | `@${string}`],
	refresh?:ValueTypes["AuthType"],
	logout?:boolean | `@${string}`,
deleteUser?: [{	id: number | Variable<any, string>},boolean | `@${string}`],
updateUser?: [{	updateUserInput: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["UpdatedUserWithTokens"]],
	createTracking?:ValueTypes["SoloTracking"],
pickAvatar?: [{	avatarId: string | Variable<any, string>},ValueTypes["User"]],
validateAnswer?: [{	validateAnswerInput: ValueTypes["ValidateAnswerInput"] | Variable<any, string>},ValueTypes["ValidatedAnswer"]],
validateBatchAnswers?: [{	answerIds: Array<string> | Variable<any, string>,	trackingId: string | Variable<any, string>},ValueTypes["SoloTracking"]],
acceptChallenge?: [{	battleId: string | Variable<any, string>},ValueTypes["BattleTracking"]],
declineChallenge?: [{	battleId: string | Variable<any, string>},boolean | `@${string}`],
createBattle?: [{	challengedId: string | Variable<any, string>},ValueTypes["BattleTracking"]],
quitBattle?: [{	battlePlayerTrackingId: string | Variable<any, string>},boolean | `@${string}`],
validateBattleAnswer?: [{	input: ValueTypes["ValidateBattleAnswerInput"] | Variable<any, string>},ValueTypes["ValidatedBattleAnswer"]],
awardBonusCrown?: [{	battlePlayerTrackingId: string | Variable<any, string>},ValueTypes["ValidatedCrown"]],
testBattleNotification?: [{	from: string | Variable<any, string>,	to: string | Variable<any, string>,	type: string | Variable<any, string>,	isWinner: boolean | Variable<any, string>},boolean | `@${string}`],
addToFriendsList?: [{	friendId: string | Variable<any, string>},ValueTypes["User"]],
removeFromFriendsList?: [{	friendId: string | Variable<any, string>},ValueTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UpdateUserInput"]: {
	isChallengeable?: boolean | undefined | null | Variable<any, string>,
	newUsername?: string | undefined | null | Variable<any, string>,
	avatarId?: string | undefined | null | Variable<any, string>
};
	["ValidateAnswerInput"]: {
	answerId?: string | undefined | null | Variable<any, string>,
	time: number | Variable<any, string>,
	trackingId: string | Variable<any, string>,
	questionId: string | Variable<any, string>
};
	["ValidateBattleAnswerInput"]: {
	answerId?: string | undefined | null | Variable<any, string>,
	questionId: string | Variable<any, string>,
	themeId?: string | undefined | null | Variable<any, string>,
	battlePlayerTrackingId: string | Variable<any, string>,
	isChallenger: boolean | Variable<any, string>,
	isBonusCrown: boolean | Variable<any, string>
};
	["Subscription"]: AliasType<{
battleSubscription?: [{	username: string | Variable<any, string>},ValueTypes["BattleNotification"]],
		__typename?: boolean | `@${string}`
}>
  }

export type ResolverInputTypes = {
    ["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ResolverInputTypes["Roles"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["Roles"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ResolverInputTypes["Permissions"],
	users?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["Avatar"]: AliasType<{
	id?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatedUserTokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	isChallengeable?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ResolverInputTypes["Roles"],
	roleId?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ResolverInputTypes["User"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LeaderboardEntry"]: AliasType<{
	username?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
		__typename?: boolean | `@${string}`
}>;
	["UpdatedUser"]: AliasType<{
	username?:boolean | `@${string}`,
	isChallengeable?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdatedUserWithTokens"]: AliasType<{
	tokens?:ResolverInputTypes["UpdatedUserTokens"],
	updatedUser?:ResolverInputTypes["UpdatedUser"],
		__typename?: boolean | `@${string}`
}>;
	["Tokens"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	sub?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AuthUser"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	isChallengeable?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	uuid?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TrackedAnswer"]: AliasType<{
	id?:boolean | `@${string}`,
	answerId?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SoloTracking"]: AliasType<{
	id?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	position?:boolean | `@${string}`,
	isCompleted?:boolean | `@${string}`,
	finalScore?:boolean | `@${string}`,
	trackedAnswers?:ResolverInputTypes["TrackedAnswer"],
		__typename?: boolean | `@${string}`
}>;
	["ValidatedAnswer"]: AliasType<{
	tracking?:ResolverInputTypes["SoloTracking"],
	correctAnswerId?:boolean | `@${string}`,
	turn?:boolean | `@${string}`,
	level?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleCheck"]: AliasType<{
	hasFinishedBattles?:boolean | `@${string}`,
	hasPendingBattles?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleScore"]: AliasType<{
	turn?:boolean | `@${string}`,
	crownCount?:boolean | `@${string}`,
	badges?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChallengeableUser"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	wonBattles?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
	battleStatus?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleStatus"]:BattleStatus;
	["SentBattles"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	wonBattles?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
	battleStatus?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleUser"]: AliasType<{
	username?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
	id?:boolean | `@${string}`,
	score?:ResolverInputTypes["BattleScore"],
		__typename?: boolean | `@${string}`
}>;
	["BattleTracking"]: AliasType<{
	id?:boolean | `@${string}`,
	battlePlayerTrackingId?:boolean | `@${string}`,
	challenger?:ResolverInputTypes["BattleUser"],
	challenged?:ResolverInputTypes["BattleUser"],
	currentPlayerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PendingBattle"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	challenger?:ResolverInputTypes["ChallengeableUser"],
	ttl?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	currentPlayerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinishedBattle"]: AliasType<{
	isWinner?:boolean | `@${string}`,
	isChallenger?:boolean | `@${string}`,
	opponent?:ResolverInputTypes["BattleUser"],
	date?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableChallengers"]: AliasType<{
	challengeableFriends?:ResolverInputTypes["ChallengeableUser"],
	challengeableUsers?:ResolverInputTypes["ChallengeableUser"],
		__typename?: boolean | `@${string}`
}>;
	["Winner"]: AliasType<{
	opponent?:boolean | `@${string}`,
	isWinner?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BattleNotification"]: AliasType<{
	from?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	isWinner?:boolean | `@${string}`,
	battlePlayerTrackingId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationType"]:NotificationType;
	["ValidatedBattleAnswer"]: AliasType<{
	currentTurn?:boolean | `@${string}`,
	badges?:boolean | `@${string}`,
	crownCount?:boolean | `@${string}`,
	correctAnswerId?:boolean | `@${string}`,
	turnEnded?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidatedCrown"]: AliasType<{
	crownCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Friend"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	wonBattles?:boolean | `@${string}`,
	avatar?:ResolverInputTypes["Avatar"],
	isFriend?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Theme"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	wheelFileName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Picture"]: AliasType<{
	id?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CurrentThemeAnswers"]: AliasType<{
	index?:boolean | `@${string}`,
	isCorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartialAnswer"]: AliasType<{
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Question"]: AliasType<{
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	theme?:ResolverInputTypes["Theme"],
	answers?:ResolverInputTypes["PartialAnswer"],
	picture?:ResolverInputTypes["Picture"],
		__typename?: boolean | `@${string}`
}>;
	["QuestionsWithStatus"]: AliasType<{
	questions?:ResolverInputTypes["Question"],
	currentThemeAnswers?:ResolverInputTypes["CurrentThemeAnswers"],
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ResolverInputTypes["Health"],
getRole?: [{	id: number},ResolverInputTypes["Roles"]],
	getRoles?:ResolverInputTypes["Roles"],
getPermission?: [{	id: number},ResolverInputTypes["Permissions"]],
	getPermissions?:ResolverInputTypes["Permissions"],
getMail?: [{	id: number},ResolverInputTypes["Mail"]],
	getMails?:ResolverInputTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string},ResolverInputTypes["AuthType"]],
login?: [{	username: string},ResolverInputTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string},ResolverInputTypes["UniqueAuth"]],
getUser?: [{	id: number},ResolverInputTypes["User"]],
	getUsers?:ResolverInputTypes["User"],
	getLeaderboard?:ResolverInputTypes["LeaderboardEntry"],
	findOpponents?:ResolverInputTypes["User"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ResolverInputTypes["FindManyUserWithFiltersInput"]},ResolverInputTypes["UserPagination"]],
	getThemes?:ResolverInputTypes["Theme"],
getQuestionById?: [{	questionId: string},ResolverInputTypes["Question"]],
getRandomQuestions?: [{	themeId?: string | undefined | null,	trackingId: string},ResolverInputTypes["QuestionsWithStatus"]],
getBattleQuestion?: [{	themeId?: string | undefined | null,	battlePlayerTrackingId: string},ResolverInputTypes["Question"]],
	getTrackings?:ResolverInputTypes["SoloTracking"],
getTrackingById?: [{	trackingId: string},ResolverInputTypes["SoloTracking"]],
	getAvatars?:ResolverInputTypes["Avatar"],
getBattlePlayerTrackingById?: [{	battlePlayerTrackingId: string},ResolverInputTypes["BattleTracking"]],
getAvailableChallengers?: [{	searchText?: string | undefined | null},ResolverInputTypes["AvailableChallengers"]],
	getPendingBattles?:ResolverInputTypes["PendingBattle"],
	getSentBattles?:ResolverInputTypes["SentBattles"],
	getFinishedBattles?:ResolverInputTypes["FinishedBattle"],
getWinner?: [{	battleTrackingId: string},ResolverInputTypes["Winner"]],
	checkBattles?:ResolverInputTypes["BattleCheck"],
	getFriendsList?:ResolverInputTypes["Friend"],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{
	AuthReponse?:ResolverInputTypes["AuthReponse"],
	CustomError?:ResolverInputTypes["CustomError"],
		__typename?: boolean | `@${string}`
}>;
	["AuthReponse"]: AliasType<{
	tokens?:ResolverInputTypes["Tokens"],
	user?:ResolverInputTypes["AuthUser"],
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ResolverInputTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	firstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	role?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined | null
};
	["Mutation"]: AliasType<{
register?: [{	username: string,	avatarId: string},ResolverInputTypes["AuthType"]],
askForResetPassword?: [{	email: string},boolean | `@${string}`],
resetPassword?: [{	email: string,	password: string,	token: string},boolean | `@${string}`],
verifyEmail?: [{	email: string,	token: string},boolean | `@${string}`],
finishRegister?: [{	email: string,	password: string,	firstName: string,	lastName: string,	token: string},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string,	password: string,	firstName: string,	lastName: string},boolean | `@${string}`],
	refresh?:ResolverInputTypes["AuthType"],
	logout?:boolean | `@${string}`,
deleteUser?: [{	id: number},boolean | `@${string}`],
updateUser?: [{	updateUserInput: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["UpdatedUserWithTokens"]],
	createTracking?:ResolverInputTypes["SoloTracking"],
pickAvatar?: [{	avatarId: string},ResolverInputTypes["User"]],
validateAnswer?: [{	validateAnswerInput: ResolverInputTypes["ValidateAnswerInput"]},ResolverInputTypes["ValidatedAnswer"]],
validateBatchAnswers?: [{	answerIds: Array<string>,	trackingId: string},ResolverInputTypes["SoloTracking"]],
acceptChallenge?: [{	battleId: string},ResolverInputTypes["BattleTracking"]],
declineChallenge?: [{	battleId: string},boolean | `@${string}`],
createBattle?: [{	challengedId: string},ResolverInputTypes["BattleTracking"]],
quitBattle?: [{	battlePlayerTrackingId: string},boolean | `@${string}`],
validateBattleAnswer?: [{	input: ResolverInputTypes["ValidateBattleAnswerInput"]},ResolverInputTypes["ValidatedBattleAnswer"]],
awardBonusCrown?: [{	battlePlayerTrackingId: string},ResolverInputTypes["ValidatedCrown"]],
testBattleNotification?: [{	from: string,	to: string,	type: string,	isWinner: boolean},boolean | `@${string}`],
addToFriendsList?: [{	friendId: string},ResolverInputTypes["User"]],
removeFromFriendsList?: [{	friendId: string},ResolverInputTypes["User"]],
		__typename?: boolean | `@${string}`
}>;
	["UpdateUserInput"]: {
	isChallengeable?: boolean | undefined | null,
	newUsername?: string | undefined | null,
	avatarId?: string | undefined | null
};
	["ValidateAnswerInput"]: {
	answerId?: string | undefined | null,
	time: number,
	trackingId: string,
	questionId: string
};
	["ValidateBattleAnswerInput"]: {
	answerId?: string | undefined | null,
	questionId: string,
	themeId?: string | undefined | null,
	battlePlayerTrackingId: string,
	isChallenger: boolean,
	isBonusCrown: boolean
};
	["Subscription"]: AliasType<{
battleSubscription?: [{	username: string},ResolverInputTypes["BattleNotification"]],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
	subscription?:ResolverInputTypes["Subscription"],
		__typename?: boolean | `@${string}`
}>
  }

export type ModelTypes = {
    ["Health"]: {
		env: string,
	time: string,
	status: string
};
	["Permissions"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	roles: Array<ModelTypes["Roles"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:any;
	["Roles"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	permissions: Array<ModelTypes["Permissions"] | undefined>,
	users: Array<ModelTypes["User"] | undefined>
};
	["Avatar"]: {
		id: string,
	fileName: string
};
	["UpdatedUserTokens"]: {
		access_token: string,
	refresh_token: string
};
	["User"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	status: ModelTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined,
	passwordResetExpiryDate?: ModelTypes["DateTime"] | undefined,
	activateAccountToken?: string | undefined,
	activateAccountExpiryDate?: ModelTypes["DateTime"] | undefined,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined,
	verifyEmailExpiryDate?: ModelTypes["DateTime"] | undefined,
	firstName: string,
	lastName: string,
	username: string,
	isChallengeable?: boolean | undefined,
	refreshToken?: string | undefined,
	role: ModelTypes["Roles"],
	roleId: number,
	avatar?: ModelTypes["Avatar"] | undefined
};
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: {
		users: Array<ModelTypes["User"] | undefined>,
	total: number
};
	["LeaderboardEntry"]: {
		username: string,
	position: number,
	score: number,
	avatar?: ModelTypes["Avatar"] | undefined
};
	["UpdatedUser"]: {
		username: string,
	isChallengeable: boolean
};
	["UpdatedUserWithTokens"]: {
		tokens?: ModelTypes["UpdatedUserTokens"] | undefined,
	updatedUser: ModelTypes["UpdatedUser"]
};
	["Tokens"]: {
		access_token: string,
	refresh_token: string
};
	["UniqueAuth"]: {
		access_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	sub: number
};
	["AuthUser"]: {
		id: number,
	username: string,
	isChallengeable?: boolean | undefined,
	avatar?: ModelTypes["Avatar"] | undefined
};
	["Mail"]: {
		id: number,
	uuid: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["TrackedAnswer"]: {
		id: string,
	answerId?: string | undefined,
	time: number
};
	["SoloTracking"]: {
		id: string,
	userId: string,
	position: number,
	isCompleted: boolean,
	finalScore?: number | undefined,
	trackedAnswers: Array<ModelTypes["TrackedAnswer"]>
};
	["ValidatedAnswer"]: {
		tracking?: ModelTypes["SoloTracking"] | undefined,
	correctAnswerId: string,
	turn: number,
	level: number
};
	["BattleCheck"]: {
		hasFinishedBattles: boolean,
	hasPendingBattles: boolean
};
	["BattleScore"]: {
		turn: number,
	crownCount: number,
	badges: Array<string>
};
	["ChallengeableUser"]: {
		id: string,
	username: string,
	wonBattles: number,
	avatar?: ModelTypes["Avatar"] | undefined,
	battleStatus: ModelTypes["BattleStatus"]
};
	["BattleStatus"]:BattleStatus;
	["SentBattles"]: {
		id: string,
	username: string,
	wonBattles: number,
	avatar?: ModelTypes["Avatar"] | undefined,
	battleStatus: ModelTypes["BattleStatus"],
	createdAt: ModelTypes["DateTime"]
};
	["BattleUser"]: {
		username: string,
	avatar?: ModelTypes["Avatar"] | undefined,
	id: string,
	score: ModelTypes["BattleScore"]
};
	["BattleTracking"]: {
		id: string,
	battlePlayerTrackingId: string,
	challenger: ModelTypes["BattleUser"],
	challenged: ModelTypes["BattleUser"],
	currentPlayerId: string
};
	["PendingBattle"]: {
		id: string,
	createdAt: ModelTypes["DateTime"],
	challenger: ModelTypes["ChallengeableUser"],
	ttl: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	currentPlayerId?: string | undefined
};
	["FinishedBattle"]: {
		isWinner: boolean,
	isChallenger: boolean,
	opponent: ModelTypes["BattleUser"],
	date: ModelTypes["DateTime"]
};
	["AvailableChallengers"]: {
		challengeableFriends: Array<ModelTypes["ChallengeableUser"]>,
	challengeableUsers: Array<ModelTypes["ChallengeableUser"]>
};
	["Winner"]: {
		opponent: string,
	isWinner: boolean
};
	["BattleNotification"]: {
		from: string,
	type: ModelTypes["NotificationType"],
	isWinner?: boolean | undefined,
	battlePlayerTrackingId?: string | undefined
};
	["NotificationType"]:NotificationType;
	["ValidatedBattleAnswer"]: {
		currentTurn: number,
	badges: Array<string>,
	crownCount: number,
	correctAnswerId: string,
	turnEnded: boolean
};
	["ValidatedCrown"]: {
		crownCount: number
};
	["Friend"]: {
		id: string,
	username: string,
	wonBattles: number,
	avatar?: ModelTypes["Avatar"] | undefined,
	isFriend: boolean,
	createdAt?: ModelTypes["DateTime"] | undefined
};
	["Theme"]: {
		id: string,
	name: string,
	fileName: string,
	wheelFileName: string
};
	["Picture"]: {
		id: string,
	fileName: string
};
	["CurrentThemeAnswers"]: {
		index: number,
	isCorrect: boolean
};
	["PartialAnswer"]: {
		id: string,
	text: string
};
	["Question"]: {
		id: string,
	text: string,
	theme: ModelTypes["Theme"],
	answers: Array<ModelTypes["PartialAnswer"]>,
	picture: ModelTypes["Picture"]
};
	["QuestionsWithStatus"]: {
		questions: Array<ModelTypes["Question"]>,
	currentThemeAnswers: Array<ModelTypes["CurrentThemeAnswers"]>
};
	["Query"]: {
		getHealthGql: ModelTypes["Health"],
	getRole: ModelTypes["Roles"],
	getRoles: Array<ModelTypes["Roles"]>,
	getPermission: ModelTypes["Permissions"],
	getPermissions: Array<ModelTypes["Permissions"]>,
	getMail: ModelTypes["Mail"],
	getMails: Array<ModelTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: ModelTypes["AuthType"],
	login: ModelTypes["AuthType"],
	uniqueAuthFromSso: ModelTypes["UniqueAuth"],
	getUser: ModelTypes["User"],
	getUsers: Array<ModelTypes["User"]>,
	getLeaderboard: Array<ModelTypes["LeaderboardEntry"]>,
	findOpponents: Array<ModelTypes["User"]>,
	getFilteredUsers: ModelTypes["UserPagination"],
	getThemes: Array<ModelTypes["Theme"]>,
	getQuestionById?: ModelTypes["Question"] | undefined,
	getRandomQuestions: ModelTypes["QuestionsWithStatus"],
	getBattleQuestion: ModelTypes["Question"],
	getTrackings: Array<ModelTypes["SoloTracking"]>,
	getTrackingById: ModelTypes["SoloTracking"],
	getAvatars: Array<ModelTypes["Avatar"]>,
	getBattlePlayerTrackingById: ModelTypes["BattleTracking"],
	getAvailableChallengers: ModelTypes["AvailableChallengers"],
	getPendingBattles: Array<ModelTypes["PendingBattle"]>,
	getSentBattles: Array<ModelTypes["SentBattles"]>,
	getFinishedBattles: Array<ModelTypes["FinishedBattle"]>,
	getWinner: ModelTypes["Winner"],
	checkBattles: ModelTypes["BattleCheck"],
	getFriendsList: Array<ModelTypes["Friend"]>
};
	["AuthType"]:ModelTypes["AuthReponse"] | ModelTypes["CustomError"];
	["AuthReponse"]: {
		tokens: ModelTypes["Tokens"],
	user: ModelTypes["AuthUser"]
};
	["CustomError"]: {
		error?: ModelTypes["EError"] | undefined,
	message?: string | undefined
};
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ModelTypes["UserOrderByInput"] | undefined,
	filterBy?: ModelTypes["UserFilterByInput"] | undefined
};
	["UserOrderByInput"]: {
	email?: ModelTypes["OrderByEnum"] | undefined,
	firstName?: ModelTypes["OrderByEnum"] | undefined,
	lastName?: ModelTypes["OrderByEnum"] | undefined,
	lastConnectionAt?: ModelTypes["OrderByEnum"] | undefined,
	role?: ModelTypes["OrderByEnum"] | undefined
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<number> | undefined
};
	["Mutation"]: {
		register: ModelTypes["AuthType"],
	askForResetPassword: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: ModelTypes["AuthType"],
	logout: boolean,
	deleteUser: boolean,
	updateUser: ModelTypes["UpdatedUserWithTokens"],
	createTracking: ModelTypes["SoloTracking"],
	pickAvatar: ModelTypes["User"],
	validateAnswer: ModelTypes["ValidatedAnswer"],
	validateBatchAnswers: ModelTypes["SoloTracking"],
	acceptChallenge: ModelTypes["BattleTracking"],
	declineChallenge: boolean,
	createBattle: ModelTypes["BattleTracking"],
	quitBattle: boolean,
	validateBattleAnswer: ModelTypes["ValidatedBattleAnswer"],
	awardBonusCrown: ModelTypes["ValidatedCrown"],
	testBattleNotification: boolean,
	addToFriendsList: ModelTypes["User"],
	removeFromFriendsList: ModelTypes["User"]
};
	["UpdateUserInput"]: {
	isChallengeable?: boolean | undefined,
	newUsername?: string | undefined,
	avatarId?: string | undefined
};
	["ValidateAnswerInput"]: {
	answerId?: string | undefined,
	time: number,
	trackingId: string,
	questionId: string
};
	["ValidateBattleAnswerInput"]: {
	answerId?: string | undefined,
	questionId: string,
	themeId?: string | undefined,
	battlePlayerTrackingId: string,
	isChallenger: boolean,
	isBonusCrown: boolean
};
	["Subscription"]: {
		battleSubscription?: ModelTypes["BattleNotification"] | undefined
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined,
	mutation?: ModelTypes["Mutation"] | undefined,
	subscription?: ModelTypes["Subscription"] | undefined
}
    }

export type GraphQLTypes = {
    // ------------------------------------------------------;
	// THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY);
	// ------------------------------------------------------;
	["Health"]: {
	__typename: "Health",
	env: string,
	time: string,
	status: string
};
	["Permissions"]: {
	__typename: "Permissions",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	roles: Array<GraphQLTypes["Roles"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["Roles"]: {
	__typename: "Roles",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	permissions: Array<GraphQLTypes["Permissions"] | undefined>,
	users: Array<GraphQLTypes["User"] | undefined>
};
	["Avatar"]: {
	__typename: "Avatar",
	id: string,
	fileName: string
};
	["UpdatedUserTokens"]: {
	__typename: "UpdatedUserTokens",
	access_token: string,
	refresh_token: string
};
	["User"]: {
	__typename: "User",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	status: GraphQLTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined,
	passwordResetExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	activateAccountToken?: string | undefined,
	activateAccountExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined,
	verifyEmailExpiryDate?: GraphQLTypes["DateTime"] | undefined,
	firstName: string,
	lastName: string,
	username: string,
	isChallengeable?: boolean | undefined,
	refreshToken?: string | undefined,
	role: GraphQLTypes["Roles"],
	roleId: number,
	avatar?: GraphQLTypes["Avatar"] | undefined
};
	["AccountStatus"]: AccountStatus;
	["UserPagination"]: {
	__typename: "UserPagination",
	users: Array<GraphQLTypes["User"] | undefined>,
	total: number
};
	["LeaderboardEntry"]: {
	__typename: "LeaderboardEntry",
	username: string,
	position: number,
	score: number,
	avatar?: GraphQLTypes["Avatar"] | undefined
};
	["UpdatedUser"]: {
	__typename: "UpdatedUser",
	username: string,
	isChallengeable: boolean
};
	["UpdatedUserWithTokens"]: {
	__typename: "UpdatedUserWithTokens",
	tokens?: GraphQLTypes["UpdatedUserTokens"] | undefined,
	updatedUser: GraphQLTypes["UpdatedUser"]
};
	["Tokens"]: {
	__typename: "Tokens",
	access_token: string,
	refresh_token: string
};
	["UniqueAuth"]: {
	__typename: "UniqueAuth",
	access_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	sub: number
};
	["AuthUser"]: {
	__typename: "AuthUser",
	id: number,
	username: string,
	isChallengeable?: boolean | undefined,
	avatar?: GraphQLTypes["Avatar"] | undefined
};
	["Mail"]: {
	__typename: "Mail",
	id: number,
	uuid: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["TrackedAnswer"]: {
	__typename: "TrackedAnswer",
	id: string,
	answerId?: string | undefined,
	time: number
};
	["SoloTracking"]: {
	__typename: "SoloTracking",
	id: string,
	userId: string,
	position: number,
	isCompleted: boolean,
	finalScore?: number | undefined,
	trackedAnswers: Array<GraphQLTypes["TrackedAnswer"]>
};
	["ValidatedAnswer"]: {
	__typename: "ValidatedAnswer",
	tracking?: GraphQLTypes["SoloTracking"] | undefined,
	correctAnswerId: string,
	turn: number,
	level: number
};
	["BattleCheck"]: {
	__typename: "BattleCheck",
	hasFinishedBattles: boolean,
	hasPendingBattles: boolean
};
	["BattleScore"]: {
	__typename: "BattleScore",
	turn: number,
	crownCount: number,
	badges: Array<string>
};
	["ChallengeableUser"]: {
	__typename: "ChallengeableUser",
	id: string,
	username: string,
	wonBattles: number,
	avatar?: GraphQLTypes["Avatar"] | undefined,
	battleStatus: GraphQLTypes["BattleStatus"]
};
	["BattleStatus"]: BattleStatus;
	["SentBattles"]: {
	__typename: "SentBattles",
	id: string,
	username: string,
	wonBattles: number,
	avatar?: GraphQLTypes["Avatar"] | undefined,
	battleStatus: GraphQLTypes["BattleStatus"],
	createdAt: GraphQLTypes["DateTime"]
};
	["BattleUser"]: {
	__typename: "BattleUser",
	username: string,
	avatar?: GraphQLTypes["Avatar"] | undefined,
	id: string,
	score: GraphQLTypes["BattleScore"]
};
	["BattleTracking"]: {
	__typename: "BattleTracking",
	id: string,
	battlePlayerTrackingId: string,
	challenger: GraphQLTypes["BattleUser"],
	challenged: GraphQLTypes["BattleUser"],
	currentPlayerId: string
};
	["PendingBattle"]: {
	__typename: "PendingBattle",
	id: string,
	createdAt: GraphQLTypes["DateTime"],
	challenger: GraphQLTypes["ChallengeableUser"],
	ttl: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	currentPlayerId?: string | undefined
};
	["FinishedBattle"]: {
	__typename: "FinishedBattle",
	isWinner: boolean,
	isChallenger: boolean,
	opponent: GraphQLTypes["BattleUser"],
	date: GraphQLTypes["DateTime"]
};
	["AvailableChallengers"]: {
	__typename: "AvailableChallengers",
	challengeableFriends: Array<GraphQLTypes["ChallengeableUser"]>,
	challengeableUsers: Array<GraphQLTypes["ChallengeableUser"]>
};
	["Winner"]: {
	__typename: "Winner",
	opponent: string,
	isWinner: boolean
};
	["BattleNotification"]: {
	__typename: "BattleNotification",
	from: string,
	type: GraphQLTypes["NotificationType"],
	isWinner?: boolean | undefined,
	battlePlayerTrackingId?: string | undefined
};
	["NotificationType"]: NotificationType;
	["ValidatedBattleAnswer"]: {
	__typename: "ValidatedBattleAnswer",
	currentTurn: number,
	badges: Array<string>,
	crownCount: number,
	correctAnswerId: string,
	turnEnded: boolean
};
	["ValidatedCrown"]: {
	__typename: "ValidatedCrown",
	crownCount: number
};
	["Friend"]: {
	__typename: "Friend",
	id: string,
	username: string,
	wonBattles: number,
	avatar?: GraphQLTypes["Avatar"] | undefined,
	isFriend: boolean,
	createdAt?: GraphQLTypes["DateTime"] | undefined
};
	["Theme"]: {
	__typename: "Theme",
	id: string,
	name: string,
	fileName: string,
	wheelFileName: string
};
	["Picture"]: {
	__typename: "Picture",
	id: string,
	fileName: string
};
	["CurrentThemeAnswers"]: {
	__typename: "CurrentThemeAnswers",
	index: number,
	isCorrect: boolean
};
	["PartialAnswer"]: {
	__typename: "PartialAnswer",
	id: string,
	text: string
};
	["Question"]: {
	__typename: "Question",
	id: string,
	text: string,
	theme: GraphQLTypes["Theme"],
	answers: Array<GraphQLTypes["PartialAnswer"]>,
	picture: GraphQLTypes["Picture"]
};
	["QuestionsWithStatus"]: {
	__typename: "QuestionsWithStatus",
	questions: Array<GraphQLTypes["Question"]>,
	currentThemeAnswers: Array<GraphQLTypes["CurrentThemeAnswers"]>
};
	["Query"]: {
	__typename: "Query",
	getHealthGql: GraphQLTypes["Health"],
	getRole: GraphQLTypes["Roles"],
	getRoles: Array<GraphQLTypes["Roles"]>,
	getPermission: GraphQLTypes["Permissions"],
	getPermissions: Array<GraphQLTypes["Permissions"]>,
	getMail: GraphQLTypes["Mail"],
	getMails: Array<GraphQLTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: GraphQLTypes["AuthType"],
	login: GraphQLTypes["AuthType"],
	uniqueAuthFromSso: GraphQLTypes["UniqueAuth"],
	getUser: GraphQLTypes["User"],
	getUsers: Array<GraphQLTypes["User"]>,
	getLeaderboard: Array<GraphQLTypes["LeaderboardEntry"]>,
	findOpponents: Array<GraphQLTypes["User"]>,
	getFilteredUsers: GraphQLTypes["UserPagination"],
	getThemes: Array<GraphQLTypes["Theme"]>,
	getQuestionById?: GraphQLTypes["Question"] | undefined,
	getRandomQuestions: GraphQLTypes["QuestionsWithStatus"],
	getBattleQuestion: GraphQLTypes["Question"],
	getTrackings: Array<GraphQLTypes["SoloTracking"]>,
	getTrackingById: GraphQLTypes["SoloTracking"],
	getAvatars: Array<GraphQLTypes["Avatar"]>,
	getBattlePlayerTrackingById: GraphQLTypes["BattleTracking"],
	getAvailableChallengers: GraphQLTypes["AvailableChallengers"],
	getPendingBattles: Array<GraphQLTypes["PendingBattle"]>,
	getSentBattles: Array<GraphQLTypes["SentBattles"]>,
	getFinishedBattles: Array<GraphQLTypes["FinishedBattle"]>,
	getWinner: GraphQLTypes["Winner"],
	checkBattles: GraphQLTypes["BattleCheck"],
	getFriendsList: Array<GraphQLTypes["Friend"]>
};
	["AuthType"]:{
        	__typename:"AuthReponse" | "CustomError"
        	['...on AuthReponse']: '__union' & GraphQLTypes["AuthReponse"];
	['...on CustomError']: '__union' & GraphQLTypes["CustomError"];
};
	["AuthReponse"]: {
	__typename: "AuthReponse",
	tokens: GraphQLTypes["Tokens"],
	user: GraphQLTypes["AuthUser"]
};
	["CustomError"]: {
	__typename: "CustomError",
	error?: GraphQLTypes["EError"] | undefined,
	message?: string | undefined
};
	["EError"]: EError;
	["FindManyUserWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput: string,
	orderBy?: GraphQLTypes["UserOrderByInput"] | undefined,
	filterBy?: GraphQLTypes["UserFilterByInput"] | undefined
};
	["UserOrderByInput"]: {
		email?: GraphQLTypes["OrderByEnum"] | undefined,
	firstName?: GraphQLTypes["OrderByEnum"] | undefined,
	lastName?: GraphQLTypes["OrderByEnum"] | undefined,
	lastConnectionAt?: GraphQLTypes["OrderByEnum"] | undefined,
	role?: GraphQLTypes["OrderByEnum"] | undefined
};
	["OrderByEnum"]: OrderByEnum;
	["UserFilterByInput"]: {
		role?: Array<number> | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	register: GraphQLTypes["AuthType"],
	askForResetPassword: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: GraphQLTypes["AuthType"],
	logout: boolean,
	deleteUser: boolean,
	updateUser: GraphQLTypes["UpdatedUserWithTokens"],
	createTracking: GraphQLTypes["SoloTracking"],
	pickAvatar: GraphQLTypes["User"],
	validateAnswer: GraphQLTypes["ValidatedAnswer"],
	validateBatchAnswers: GraphQLTypes["SoloTracking"],
	acceptChallenge: GraphQLTypes["BattleTracking"],
	declineChallenge: boolean,
	createBattle: GraphQLTypes["BattleTracking"],
	quitBattle: boolean,
	validateBattleAnswer: GraphQLTypes["ValidatedBattleAnswer"],
	awardBonusCrown: GraphQLTypes["ValidatedCrown"],
	testBattleNotification: boolean,
	addToFriendsList: GraphQLTypes["User"],
	removeFromFriendsList: GraphQLTypes["User"]
};
	["UpdateUserInput"]: {
		isChallengeable?: boolean | undefined,
	newUsername?: string | undefined,
	avatarId?: string | undefined
};
	["ValidateAnswerInput"]: {
		answerId?: string | undefined,
	time: number,
	trackingId: string,
	questionId: string
};
	["ValidateBattleAnswerInput"]: {
		answerId?: string | undefined,
	questionId: string,
	themeId?: string | undefined,
	battlePlayerTrackingId: string,
	isChallenger: boolean,
	isBonusCrown: boolean
};
	["Subscription"]: {
	__typename: "Subscription",
	battleSubscription?: GraphQLTypes["BattleNotification"] | undefined
}
    }
export const enum AccountStatus {
	PENDING_ACTIVATION = "PENDING_ACTIVATION",
	ENABLED = "ENABLED",
	DISABLED = "DISABLED"
}
export const enum BattleStatus {
	NOT_STARTED = "NOT_STARTED",
	IN_PROGRESS = "IN_PROGRESS",
	PENDING = "PENDING",
	DECLINED = "DECLINED",
	FINISHED = "FINISHED",
	WON = "WON",
	LOST = "LOST"
}
export const enum NotificationType {
	CHALLENGE_ACCEPTED = "CHALLENGE_ACCEPTED",
	CHALLENGE_DECLINED = "CHALLENGE_DECLINED",
	BATTLE_INVITE = "BATTLE_INVITE",
	BATTLE_FINISHED = "BATTLE_FINISHED",
	NEXT_TURN = "NEXT_TURN"
}
export const enum EError {
	AUTH = "AUTH"
}
export const enum OrderByEnum {
	ASC = "ASC",
	DESC = "DESC"
}

type ZEUS_VARIABLES = {
	["DateTime"]: ValueTypes["DateTime"];
	["AccountStatus"]: ValueTypes["AccountStatus"];
	["BattleStatus"]: ValueTypes["BattleStatus"];
	["NotificationType"]: ValueTypes["NotificationType"];
	["EError"]: ValueTypes["EError"];
	["FindManyUserWithFiltersInput"]: ValueTypes["FindManyUserWithFiltersInput"];
	["UserOrderByInput"]: ValueTypes["UserOrderByInput"];
	["OrderByEnum"]: ValueTypes["OrderByEnum"];
	["UserFilterByInput"]: ValueTypes["UserFilterByInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
	["ValidateAnswerInput"]: ValueTypes["ValidateAnswerInput"];
	["ValidateBattleAnswerInput"]: ValueTypes["ValidateBattleAnswerInput"];
}